<template>
  <v-container v-if="partner" fluid class="mx-3">
    <div
      class="d-flex justify-space-between align-center mb-5"
      style="width: 100%"
    >
      <div class="spotlight-title mx-2">
        <p class="my-0" style="font-size: 20px">
          {{ $t("dashboard.partners.title") }}
        </p>
        <p class="my-0 text-body-2 color-disabled">
          {{ $t("dashboard.partners.subtitle") }}
        </p>
      </div>
      <v-btn class="edit-button" elevation="0" :to="{ name: 'Partners' }">
        {{ $t("dashboard.partners.viewAll") }}
        <v-icon right small>mdi-arrow-right</v-icon>
      </v-btn>
    </div>
    <a
      class="spotlight-banner"
      :href="partner.website || undefined"
      target="_blank"
      rel="noopener"
    >
      <img :src="partner.image_url" :alt="partner.company" />
    </a>
  </v-container>
</template>

<script>
import * as Sentry from "@sentry/vue";
import partners from "@/api/partners";
export default {
  name: "PartnerSpotlight",
  data() {
    return {
      partner: null,
    };
  },
  methods: {
    async fetchSpotlightPartner() {
      try {
        const response = await partners.fetchSpotlightPartner();
        if (response.code == 200) {
          this.partner = response.data;
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    },
  },
  async created() {
    await this.fetchSpotlightPartner();
  },
};
</script>

<style scoped>
.edit-button {
  background-color: #2b58e2 !important;
  color: white !important;
  text-transform: none;
  font-family: sans-serif !important;
  height: 30px !important;
}

.color-disabled {
  color: #a09d9d;
}

.spotlight-title {
  border-left: 4px solid #2b58e2;
  padding-left: 12px;
}

.spotlight-banner {
  display: block;
  border-radius: 12px;
  overflow: hidden;
}

.spotlight-banner img {
  display: block;
  width: 100%;
  height: auto;
}
</style>
